import { getMascotImageSrc } from '@gem/utils';

import { FriendsSpaceMessagesEmptyConfig } from './FriendsSpaceMessagesEmpty.types';

export enum FriendsSpaceImage {
  DailyTalks = 'https://lh3.googleusercontent.com/TrocZHjLwRBCrwjB0642YiNefTOcNk0usObqKAuEjkxpzefdsuG4xhLUyR-IKrjCQMelqNwMPsuSHYnB1McYeRFIyL2LUg',
  Handouts = 'https://lh3.googleusercontent.com/rYQAQaOy5D3oqcEqMmzZTmAnHHJh28kdw84ePkx4dN-wYnLi9ghMNe7604MicA6AgDpL8o5XhW-YgOc-vSuNkZ24C8_X',
  Fun = 'https://lh3.googleusercontent.com/B8R5cDtVm3lzSGMXeDOKpDqcvim-Clk0v4QPHEJoK4zLqmwclZu0xDMln8bKbNQDIOW1CzORZM4JUdh4FgS90kxQpWwB',
  Helps = 'https://lh3.googleusercontent.com/CusdW6uR4ZcofahoMYBPGEb8pOuZPa-_Rm3rK8_lNU4CfxD_mSxeLojCSaxQzsCqWAKRtQzK8MboSjpQX1zPzpjCqNqsKA',
  News = 'https://lh3.googleusercontent.com/G_WcmgKWzEpDiRDKyWW2xz1MaTQSq0_zLZPVuPY1UUzUv-k0fPM7nubWW4YOm0pdbxEWvd-qeTADWnHumDB2Rfc09aE50g',
}

export const friendsSpaceImagesEmptyConfig: Record<string, FriendsSpaceMessagesEmptyConfig> = {
  [FriendsSpaceImage.DailyTalks]: {
    image: getMascotImageSrc(PROJECT_CONFIG.imageAssets.conversation),
    titleKey: 'space_friends_daily_name',
    descriptionKey: 'space_friends_daily_description',
  },
  [FriendsSpaceImage.Handouts]: {
    image: getMascotImageSrc(PROJECT_CONFIG.imageAssets.plans),
    titleKey: 'space_friends_hangouts_name',
    descriptionKey: 'space_friends_hangouts_description',
  },
  [FriendsSpaceImage.Fun]: {
    image: getMascotImageSrc(PROJECT_CONFIG.imageAssets.sharing),
    titleKey: 'space_friends_fun_name',
    descriptionKey: 'space_friends_fun_description',
  },
  [FriendsSpaceImage.Helps]: {
    image: getMascotImageSrc(PROJECT_CONFIG.imageAssets.help),
    titleKey: 'space_friends_help_name',
    descriptionKey: 'space_friends_help_description',
  },
  [FriendsSpaceImage.News]: {
    image: getMascotImageSrc(PROJECT_CONFIG.imageAssets.news),
    titleKey: 'space_friends_news_name',
    descriptionKey: 'space_friends_news_description',
  },
};
